import React, {useEffect} from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import s from './Total.scss';
import {TotalUpdateSkeleton} from '../SubTotals/TotalUpdateSkeleton';

export enum TotalDataHook {
  Title = 'Total.Title',
  Value = 'Total.Value',
}

export const Total = () => {
  const {t} = useTranslation();
  const {shouldDisplaySubtotalTitle: shouldDisplaySubtotalTitleOld, shouldDisplaySubtotal} =
    useControllerProps().orderStore;
  const {
    cartSummary,
    pageLoaded,
    cartModel,
    refactorCouponOnCart,
    refactorOrderSummaryInCartPage,
    changeCartLoaders,
    isSummaryUpdating,
  } = useControllerProps().cartStore;

  const shouldDisplaySubtotalTitle = refactorOrderSummaryInCartPage
    ? !shouldDisplaySubtotal
    : shouldDisplaySubtotalTitleOld;

  useEffect(
    () => {
      pageLoaded();
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ []
  );

  const getTotalValue = (): string | React.ReactNode => {
    if (changeCartLoaders && isSummaryUpdating) {
      return <TotalUpdateSkeleton size="medium" />;
    }
    return (
      cartSummary?.priceSummary.total.formattedConvertedAmount ??
      (refactorCouponOnCart
        ? cartModel.subtotal.formattedConvertedAmount
        : cartModel.subtotalAfterDiscounts.formattedConvertedAmount)
    );
  };

  return (
    <dl className={s.root}>
      <dt>
        <span id="subtotal-label" data-hook={TotalDataHook.Title}>
          {shouldDisplaySubtotalTitle ? t('cart.subtotal') : t('cart.estimated_total')}
        </span>
      </dt>

      <dd
        data-hook={TotalDataHook.Value}
        role="status"
        aria-live="polite"
        id="total-sum"
        aria-labelledby="subtotal-label"
        data-wix-cart-total-price={TotalDataHook.Value}>
        {getTotalValue()}
      </dd>
    </dl>
  );
};
